export default __webpack_public_path__ + "img/WB_NB.93ce991a69ed9833a72c962a42069b7d.jpg";